import React from 'react';
import dict from 'config/dictionary';
import externalLinks from 'config/externalLinks';
import { path, pathOr } from 'ramda';
import { interpolateMany } from './interpolate';

const userFriendlyStatuses = [422, 404, 500];

const supportLink = (
  <a href={externalLinks.email.support.url}>
    {externalLinks.email.support.label}
  </a>
);

export const fallbackError = (itemType = 'item') =>
  interpolateMany(dict.unknownAPIError, [
    ['[item_type]', <>{itemType}</>],
    ['[support_email]', supportLink]
  ]);

/**
 * @deprecated This will be removed at some point
 * @param {Object} err
 */
export const translateAPIError = err => {
  let status = Number(path(['response', 'status'], err));
  let message = userFriendlyStatuses.includes(status)
    ? pathOr(
        path(['response', 'data', 'message'], err),
        ['response', 'data', 'error'],
        err
      )
    : null;
  return message || fallbackError();
};
